"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Point2dDisplaySettings = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Point config where not specified per point. Colors are stored normalized.
 */
class Point2dDisplaySettings extends rc_js_util_1.Mat4.f32 {
    constructor(pixelSize, 
    /**
     * RGBA unit32.
     */
    color, highlightColor = color) {
        super();
        this.highlightedSegments = null;
        this.color = null;
        this.highlight = null;
        this.setSize(pixelSize);
        this.packedColor = this.setColor(color);
        this.packedHighlightColor = this.setHighlightColor(highlightColor);
    }
    setSize(size) {
        this[0] = size;
    }
    setColor(rgbaColor) {
        this.setColorImpl(rgbaColor, 4);
        return this.packedColor = this
            .getNormalizedColor()
            .getPackedRGBAColor(true);
    }
    getNormalizedColor() {
        if (this.color == null) {
            this.color = new rc_js_util_1.Vec4.f32();
        }
        return this.getRow(1, this.color);
    }
    setHighlightColor(rgbaColor) {
        this.setColorImpl(rgbaColor, 8);
        return this.packedHighlightColor = this
            .getNormalizedHighlightColor()
            .getPackedRGBAColor(true);
    }
    getNormalizedHighlightColor() {
        if (this.highlight == null) {
            this.highlight = new rc_js_util_1.Vec4.f32();
        }
        return this.getRow(2, this.highlight);
    }
    getPixelSize() {
        return this[0];
    }
    setColorImpl(rgbaColor, startIndex) {
        // 0.00392156862745098 = 1 / 255
        this[startIndex] = rc_js_util_1.RgbaColorPacker.unpackR(rgbaColor) * 0.00392156862745098;
        this[startIndex + 1] = rc_js_util_1.RgbaColorPacker.unpackG(rgbaColor) * 0.00392156862745098;
        this[startIndex + 2] = rc_js_util_1.RgbaColorPacker.unpackB(rgbaColor) * 0.00392156862745098;
        this[startIndex + 3] = rc_js_util_1.RgbaColorPacker.unpackA(rgbaColor) * 0.00392156862745098;
    }
}
exports.Point2dDisplaySettings = Point2dDisplaySettings;
//# sourceMappingURL=t-point2d-display-settings-trait.js.map